// extracted by mini-css-extract-plugin
export var box = "_3q-0";
export var check = "_3q-1";
export var checkboxButton = "_3q-6";
export var checkboxGroup = "_3q-5";
export var disabled = "_3q-7";
export var ghost = "_3q-9";
export var input = "_3q-2";
export var label = "_3q-4";
export var normal = "_3q-8";
export var uncheck = "_3q-3";